import Cookies from 'js-cookie';
import config from '@/common/config';

export const TOKEN_KEY = 'token';

export default {
  setToken(token) {
    Cookies.set(TOKEN_KEY, token, {
      expires: config.cookieExpires || 1
    });
  },
  getToken() {
    const token = Cookies.get(TOKEN_KEY);
    if (token) return token;
    else return false;
  },
  setSecret(secret) {
    Cookies.set('secret', secret, {
      expires: config.cookieExpires || 1
    });
  },
  delToken() {
    Cookies.remove(TOKEN_KEY);
  },
  pushHistory() {
    const state = {
      title: '',
      url: ''
    };
    window.history.pushState(state, state.title, state.url);
  },
  getSecret() {
    return Cookies.get('secret');
  },
  GetBrowser() {
    const browser = {
      versions() {
        const u = navigator.userAgent;
        return {
          trident: u.indexOf('Trident') > -1, // IE内核
          presto: u.indexOf('Presto') > -1, // opera内核
          webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
          gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
          mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
          android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
          iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
          iPad: u.indexOf('iPad') > -1, // 是否iPad
          webApp: u.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
          weixin: u.indexOf('MicroMessenger') > -1, // 是否微信 （2015-01-22新增）
          qq: u.match(/\sQQ/i) != null // 是否QQ
        };
      },
      language: (navigator.browserLanguage || navigator.language).toLowerCase()
    };
    return browser;
  },
  WxConfig(_appId, _timestamp, _nonceStr, _signature, self) {
    const config = {
      // 开启调试模式,调用的所有api的返回值会在客户端alert出来
      // 若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      debug: false,
      // debug: true,
      // 必填，公众号的唯一标识
      appId: _appId,
      // 必填，生成签名的时间戳
      timestamp: _timestamp,
      // 必填，生成签名的随机串
      nonceStr: _nonceStr,
      // 必填，签名，见附录1
      signature: _signature,
      // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      jsApiList: [
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'onMenuShareQZone'
        // 'getLocation' // 获取地理位置
      ]
    };

    /* eslint-disable no-undef */
    wx.config(config);

    wx.checkJsApi({
      jsApiList: config.jsApiList, // 需要检测的JS接口列表，所有JS接口列表见附录2,
      success() {
        // 以键值对的形式返回，可用的api值true，不可用为false
        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        // console.log(res);
      }
    });

    wx.ready(() => {
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后
      // config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口
      // 则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口
      // 则可以直接调用，不需要放在ready函数中。
      // console.log('WxConfig Success.');
      // eslint-disable-next-line
      self.wechatSuccess = true
    });
    wx.error(() => {
      // config信息验证失败会执行error函数，如签名过期导致验证失败
      // 具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      // console.log(res);
      // alert('WxConfig Error.');
    });

    return {
      Timeline,
      AppMessage

    };
  },
  checkForm(keys, form) {
    let result = true;
    keys.forEach(item => {
      if (!form[item]) {
        result = false;
      }
    });
    return result;
  }
};
